// Section 7: stock movements, booked to this season's flows. Stock never goes negative.
import { round6 } from '../../core/math';
import type { FlowKind, PhaseContext, Resource } from '../../core/types';

/** Add (or remove, if negative) up to what is available; returns the amount actually moved. */
export function addStock(
  ctx: PhaseContext,
  resource: Resource,
  amount: number,
  flow: FlowKind,
): number {
  const stock = ctx.draft.stocks[resource];
  const moved = amount < 0 ? -Math.min(stock.amount, -amount) : amount;
  stock.amount = Math.max(0, stock.amount + moved);
  const report = ctx.draft.currentReport;
  if (report !== null) {
    const f = report.flows[resource];
    const size = Math.abs(moved);
    switch (flow) {
      case 'production':
        f.production += moved;
        break;
      case 'consumption':
        f.consumption += size;
        break;
      case 'spoilage':
        f.spoilage += size;
        break;
      case 'theft':
        f.theft += size;
        break;
      case 'other':
        f.other += moved;
        break;
    }
    f.net = round6(f.net + moved);
  }
  return moved;
}
